import rolesData from './roles'
import lang from '@/utils/language'

export const roleOptions = [
	{ text: lang(rolesData.admin), value: rolesData.admin, can: 'create_admin' },
	{ text: lang(rolesData.stateHead), value: rolesData.stateHead, can: 'create_state_head' },
	{ text: lang(rolesData.stateStaff), value: rolesData.stateStaff, can: 'create_state_staff' },
	{ text: lang(rolesData.agencyHead), value: rolesData.agencyHead, can: 'create_agency_head' },
	{ text: lang(rolesData.agencyStaff), value: rolesData.agencyStaff, can: 'create_agency_staff' }
]

export const roleOptionsEdit = [
	{ text: lang(rolesData.stateHead), value: rolesData.stateHead, can: 'assign_state_head' },
	{ text: lang(rolesData.stateStaff), value: rolesData.stateStaff, can: 'assign_state_staff' },
	{ text: lang(rolesData.agencyHead), value: rolesData.agencyHead, can: 'assign_agency_head' },
	{ text: lang(rolesData.agencyStaff), value: rolesData.agencyStaff, can: 'assign_agency_staff' }
]

export const booleanOptions = [
	{ text: lang('yes'), value: 'yes' },
	{ text: lang('no'), value: 'no' }
]

export const statusOptions = [
	{ text: lang('active'), value: 'active' },
	{ text: lang('inactive'), value: 'inactive' }
]

export const progressOptions = [
	{ text: lang('ongoing'), value: 'ongoing' },
	{ text: lang('completed'), value: 'completed' }
]

export const verificationOptions = [
	{ text: lang('verified'), value: 'verified' },
	{ text: lang('unverified'), value: 'unverified' }
]

export const eventStatusOptions = [
	{ text: lang('unverified'), value: 'unverified' },
	{ text: lang('ongoing'), value: 'ongoing' },
	{ text: lang('ended'), value: 'ended' }
]

export const agencyTypeOptions = [
	{ text: lang('ngo'), value: 'ngo' },
	{ text: lang('ingo'), value: 'ingo' },
	{ text: lang('faith-based'), value: 'faith-based' },
	{ text: lang('government'), value: 'government' },
	{ text: lang('cso'), value: 'cso' },
	{ text: lang('philanthropist'), value: 'philanthropist' },
	{ text: lang('mda'), value: 'mda' },
	{ text: lang('other'), value: 'other' }
]
